import { Component, Fragment, type ReactNode } from 'react'

interface AppErrorBoundaryProps {
  children: ReactNode
}

interface AppErrorBoundaryState {
  error: Error | null
  retryKey: number
}

export class AppErrorBoundary extends Component<
  AppErrorBoundaryProps,
  AppErrorBoundaryState
> {
  override state: AppErrorBoundaryState = { error: null, retryKey: 0 }

  static getDerivedStateFromError(error: Error): Partial<AppErrorBoundaryState> {
    return { error }
  }

  private retry = () => {
    this.setState(({ retryKey }) => ({ error: null, retryKey: retryKey + 1 }))
  }

  override render() {
    if (this.state.error !== null) {
      return (
        <main className="fatal-state" id="main-content">
          <section aria-labelledby="fatal-state-title">
            <h1 id="fatal-state-title">数据暂时无法读取</h1>
            <p>请稍后重试。</p>
            <button type="button" onClick={this.retry}>
              重试
            </button>
          </section>
        </main>
      )
    }

    return <Fragment key={this.state.retryKey}>{this.props.children}</Fragment>
  }
}
